<template>
  <DetailsPane
    title="Enrollment Details"
    :hide-close="hideClose"
    :height="height"
    :auto-height="autoHeight"
    @close="$emit('close')"
  >
    <div class="details-pane-table p-4">
      <div class="row mb-2">
        <div class="col-4 col-attribute">Student:</div>
        <div class="col-8 col-value">
          <a
            :href="route('admin.users.edit', { user: user.id })"
            class="text-primary"
          >
            {{ user.name }}
          </a>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-4 col-attribute">Course:</div>
        <div class="col-8 col-value">
          <a
            :href="route('admin.courses.edit', { course: course.id })"
            class="text-primary"
          >
            {{ course.name }}
          </a>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-4 col-attribute">Brand:</div>
        <div class="col-8 col-value">{{ enrollment.brand.name }}</div>
      </div>

      <div class="row mb-2">
        <div class="col-4 col-attribute">Learning Path:</div>
        <div class="col-8 col-value">
          <div
            v-if="
              !!learningPathEnrollment && !!learningPathEnrollment.learning_path
            "
            class="mb-1"
          >
            {{ learningPathEnrollment.learning_path.name }}
          </div>
          <a
            v-if="!!enrollment.can_add_to_path"
            class="btn-sm btn-info"
            href="#"
            @click.prevent="addToLearningPath()"
          >
            {{ !!learningPathEnrollment ? "Re-Assign" : "Add to Path" }}
          </a>
        </div>
      </div>

      <div v-if="!!enrollment.series" class="row mb-2">
        <div class="col-4 col-attribute">Series:</div>
        <div class="col-8 col-value">{{ enrollment.series.name }}</div>
      </div>

      <div class="row mb-2">
        <div class="col-4 col-attribute">NATE Credit?:</div>
        <div class="col-8 col-value">
          <span v-if="!!enrollment.nate_id"
            >Yes, NATE ID: {{ enrollment.nate_id }}</span
          >
          <span v-else>No</span>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-4 col-attribute">Enrolled on:</div>
        <div class="col-8 col-value">
          {{ enrollment.enrolled_at | moment("M/D/YYYY") }}
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-4 col-attribute">Enrolled by:</div>
        <div class="col-8 col-value">
          <span v-if="!!enrollment.enrolledBy">{{
            enrollment.enrolledBy.name
          }}</span>
          <span v-else>N/A</span>
        </div>
      </div>
    </div>
  </DetailsPane>
</template>

<script>
import DetailsPane from "components/listings/DetailsPane";
import DetailsPaneMixin from "mixins/DetailsPane";
import AddToLearningPathModal from "../LearningPaths/AddToLearningPathModal";

export default {
  mixins: [DetailsPaneMixin],
  components: { DetailsPane },
  props: {
    enrollment: { type: Object, required: true },
  },
  data() {
    return {
      learningPathEnrollment: null,
    };
  },
  computed: {
    user() {
      return this.enrollment.user;
    },
    course() {
      return this.enrollment.enrollable;
    },
  },
  methods: {
    addToLearningPath() {
      this.$modal(AddToLearningPathModal, {
        enrollment: this.enrollment,
        learning_path_id: this.learningPathEnrollment.learning_path_id,
      })
        .then((learningPathEnrollment) => {
          this.learningPathEnrollment = _.cloneDeep(learningPathEnrollment);
        })
        .catch(() => {});
    },
  },
  created() {
    if (!!this.enrollment.learning_path_enrollment) {
      this.learningPathEnrollment = _.cloneDeep(
        this.enrollment.learning_path_enrollment
      );
    }
  },
};
</script>
